import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs1 from "./page_us/Solution-US-1/SectionUs1.js";
import { useEffect } from "react";



const PlafondsMursTendus = () =>{
    
useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Art Mural Maroc | Décoration & Design Artistique – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Art mural et décoration artistique au Maroc avec UNIK SYSTEM : impressions grand format, panneaux design et créations uniques pour sublimer vos espaces."
  );

  setMeta(
    "keywords",
    "art mural maroc, decoration murale maroc, panneau mural design maroc, impression grand format maroc, design interieur maroc, tableau mural moderne maroc, UNIK SYSTEM artflow"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/artflow-decoration-murale-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Art Mural Maroc – Design & Décoration | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Créations artistiques et décoration murale moderne pour espaces uniques."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/Mur%20tendu%20imprimé%20design%20avec%20motifs%20de%20feuilles%20artistiques%20dans%20un%20salon%20contemporain%20–%20solution%20décorative%20Unik%20System.5ff0dad41bcd8dc323e6.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/artflow-decoration-murale-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Art Mural Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Décoration murale design et artistique pour espaces modernes."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/Mur%20tendu%20imprimé%20design%20avec%20motifs%20de%20feuilles%20artistiques%20dans%20un%20salon%20contemporain%20–%20solution%20décorative%20Unik%20System.5ff0dad41bcd8dc323e6.webp"
  );

  // ========= SCHEMA (CREATIVE SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en décoration murale artistique et design intérieur au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Design Artistique",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Décoration Murale Artistique"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Impression Grand Format Design"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-artflow");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-artflow";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi la décoration murale artistique ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est l’intégration d’œuvres visuelles et designs pour personnaliser et sublimer un espace."
        }
      },
      {
        "@type": "Question",
        name: "Quels types de projets ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Maisons, hôtels, restaurants et espaces professionnels."
        }
      },
      {
        "@type": "Question",
        name: "Pourquoi choisir UNIK SYSTEM ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Créations sur mesure, qualité premium et design unique adapté à chaque projet."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-artflow");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-artflow";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);




  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs1/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;